var Header = {};
(function ($) {
  "use strict";

  $(function () {
    $(".js-map a", ".js-block-contact-map").click(function (event) {
      event.preventDefault();
      var $this = $(this);

      var href = $this.attr("href");
      console.log("href", href);

      if (!href) return false;
      var parent = $this.closest(".js-block-contact-map");
      var iframe = parent.find(".js-iframe-map");
      parent.find(".js-map").removeClass("active");
      $this.addClass("active");
      iframe.attr("src", href);
      $("html, body").animate(
        {
          scrollTop: iframe.offset().top - 200,
        },
        300
      );
      return false;
    });
  });
})(jQuery);
